<template>
  <div>
    <div class="product-detail-floor-1-container">
      <div class="product-detail-left">
        <div class="product-detail-pic">
          <img :src="productDetail.defaultImage" :alt="productDetail.skuName" />
          <!-- v-lazy="bigImg" -->
        </div>
        <div class="product-detail-small">
          <new-swiper :banners="productDetail.imageUrls" :name="'name'" :h="60"></new-swiper>
        </div>
      </div>
      <div class="product-detail-middle">
        <el-tooltip placement="top" :content="productDetail.skuName" effect="dark">
          <h3 class="product-detail-title in2clamp">
            {{ productDetail.skuName }}
          </h3>
        </el-tooltip>
        <div class="product-detail-price">
          <div class="column-1">
            <div class="floor-1">
              价格：
              <div class="floor-1-price">
                {{ productDetail.price && productDetail.price.toFixed(2) }}
              </div>
            </div>
            <div class="floor-2">
              <div class="floor-2-1">
                税&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;率：{{
                  productDetail.taxRateValue
                }}%
              </div>
              <div class="floor-2-2">计量单位：{{ productDetail.unitValue }}</div>
            </div>
          </div>
        </div>

        <div class="product-detail-attr">
          <el-row>
            <el-col :span="12" style="display: flex; align-items: center;">
              <span class="attr-item">商品编号</span>
              <i>：</i>
              <span class="attr-txt">{{ productDetail.skuCode }}</span>
            </el-col>
            <el-col :span="12" style="display: flex; align-items: center;">
              <span class="attr-item">起订量</span>
              <i>：</i>
              <span class="attr-txt">
                {{ productDetail.minOrderQuantity + productDetail.unitValue }}
              </span>
            </el-col>
          </el-row>
          <el-row class="attr-item-warp">
            <el-col :span="12" style="display: flex; align-items: center;">
              <span class="attr-item">品牌名称</span>
              <i>：</i>
              <span class="attr-txt">{{ productDetail.brandName }}</span>
            </el-col>
            <el-col :span="12" style="display: flex; align-items: center;">
              <span class="attr-item">库存</span>
              <i>：</i>
              <span>{{ productDetail.skuStock }}</span>
            </el-col>
          </el-row>
          <el-row class="attr-item-warp">
            <!-- <el-col :span="12" v-if="producteValuateLevel !== '不合格'">
              <span class="attr-item">质量评价</span>
              <i>：</i>
              <span class="attr-txt">{{ producteValuateLevel }}</span>
            </el-col> -->
            <!-- <el-col :span="12">
              <span class="attr-item">销量</span>
              <i>：</i>
              <span class="attr-txt">
                {{ productDetail.salesVolume + productDetail.unitValue }}
              </span>
            </el-col> -->
          </el-row>
        </div>
      </div>
      <div class="product-detail-right">
        <div class="product-detail-right-title">
          <el-tooltip :content="companyInfo.companyName" placement="top">
            <div class="product-detail-right-title-floor1">
              {{ companyInfo.companyName }}
            </div>
          </el-tooltip>

          <div class="product-detail-right-title-floor2">
            <div class="product-detail-right-vip-text">ESI(会员)</div>
            <div class="product-detail-right-vip-txt">
              <!-- 信<span style="font-size: 12px">3年</span> -->
            </div>
          </div>
        </div>
        <div class="product-detail-right-content">
          <div class="product-detail-line">
            <div>易派客标准指数:</div>
            <div>{{ companyInfo.strength }}</div>
          </div>
          <div class="product-detail-line">
            <div>法人信用认证:</div>
            <i
              v-if="typeof companyInfo.creditGrade == 'undefined' || companyInfo.creditGrade == ''"
              class="h-line"
            ></i>
            <div v-else>{{ companyInfo.creditGrade }}</div>
          </div>
          <div v-if="companyInfo.productGrade" class="product-detail-line">
            <div>产品质量评价:</div>
            <div>
              {{ companyInfo.productGrade !== '不合格' ? companyInfo.productGrade : '- -' }}
            </div>
          </div>
          <div class="product-detail-line">
            <div>履约动态考评:</div>
            <div>
              <el-rate
                v-model="companyInfo.gradeId"
                disabled
                :colors="['#F78515', '#F78515', '#F78515']"
              ></el-rate>
            </div>
          </div>
          <div class="product-detail-line">
            <div>市场业绩表现:</div>
            <div>
              <el-rate
                v-model="companyInfo.innovationEvaluate"
                disabled
                :colors="['#55B3CF', '#55B3CF', '#55B3CF']"
              ></el-rate>
            </div>
          </div>
          <el-row class="product-detail-line-1" style="margin-top: 20px">
            <el-col :span="8">所在地区:</el-col>
            <el-col :span="16" class="in2clamp" style="width: 130px">
              {{ companyInfo ? companyInfo.address : '' }}
            </el-col>
          </el-row>
          <el-row class="product-detail-line-1" style="margin-top: 5px">
            <el-col :span="8">联&nbsp;系&nbsp;&nbsp;人:</el-col>
            <el-col :span="14">{{ contactInfo ? contactInfo.contacts : '' }}</el-col>
          </el-row>
          <el-row class="product-detail-line-1" style="margin-top: 5px">
            <el-col :span="8">联系方式:</el-col>
            <el-col :span="14">{{ contactInfo ? contactInfo.mobile : '' }}</el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewSwiper from './newSwiper';
import api from '@/modules/projectA/api/product';
// import { validateStrLen } from '../../../utils/verification';

export default {
  name: 'ProductDetailFloor1',
  components: {
    NewSwiper,
  },
  props: {
    productDetail: {
      required: true,
      type: Object,
    },
    companyInfo: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      contactInfo: '',
      disabled: false,
    };
  },
  mounted() {},
  watch: {
    'productDetail.categoryId'(newVal) {
      if (newVal) {
        this.getContactInfo();
      }
    },
  },
  methods: {
    showToolTips(item1) {
      /* console.log(validateStrLen(item1));
      if (validateStrLen(item1) > 116) {
        this.disabled = false;
      } */
    },
    hideToolTips() {
      this.disabled = true;
    },
    getBigImg(url) {
      this.bigImg = url;
    },
    async getContactInfo() {
      const mdmParams = {
        categoryId: this.productDetail.categoryId,
      };
      const data = await api.queryMDMCodeByCategoryId(mdmParams);
      const params = {
        companyId: this.productDetail.supplierCompanyId,
        mdmCode: data.data,
      };
      const res = await api.queryContact(params);
      this.contactInfo = res.data;
      console.log(this.contactInfo);
    },
  },
};
</script>

<style>
.el-tooltip__popper {
  max-width: 500px;
}
</style>
<style lang="scss" scoped>
@import '~@/assets/css/theme.scss';
.product-detail-floor-1-container {
  padding-top: 20px;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  .product-detail-left {
    display: flex;
    flex-direction: column;
    .product-detail-flag {
      position: absolute;
      z-index: 99;
      margin-left: 20px;
      img {
        width: 40px;
        height: 50px;
      }
    }
    .product-detail-pic {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 354px;
      height: 354px;
      border: 1px solid #e2e2e2;
      img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 346px;
        height: 302px;
      }
      img[lazy='error'] {
        width: 146px !important;
        height: 100px !important;
      }
      img[lazy='loading'] {
        width: 146px !important;
        height: 100px !important;
      }
    }
    .product-detail-small {
      margin-top: 10px;
      max-width: 355px;
    }
  }
  .product-detail-middle {
    margin-left: 10px;
    .product-detail-title {
      font-size: 20px;
      width: 606px;
      color: #333333;
    }
    .product-detail-price {
      width: 606px;
      max-height: 125px;
      background: #f2f2f2;
      margin-top: 10px;
      padding-top: 10px;
      display: flex;
      line-height: 1;
      flex-direction: row;
      padding-bottom: 10px;
      .column-1 {
        width: 100%;
        .floor-1 {
          /*margin-top: 20px;*/
          margin-left: 10px;
          font-size: 14px;
          display: flex;
          flex-direction: row;
          align-items: flex-end;
          color: #333333;
          line-height: 1;
          .floor-1-price {
            font-style: normal;
            font-weight: bold;
            font-size: 28px;
            line-height: 41px;

            color: #ef260f;
            /*font-size: 28px;*/
            /*font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;*/
            /*font-weight: bold;*/
            /*color: red;*/
            line-height: 1;
            margin-bottom: -2px;
            margin-left: 2px;
          }
          .floor-1-price-2 {
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 41px;

            color: #ef260f;
            /*font-size: 28px;*/
            /*font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;*/
            /*font-weight: bold;*/
            /*color: red;*/
            line-height: 1;
            margin-bottom: -2px;
            margin-left: 2px;
          }
          .floor-2-price {
            text-decoration: line-through;
            margin-left: 12px;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 10px;
          }
          .floor-3-price {
            font-style: normal;
            font-weight: bold;
            font-size: 28px;
            line-height: 41px;

            color: #ef260f;
            /*font-size: 28px;*/
            /*font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;*/
            /*font-weight: bold;*/
            /*color: red;*/
            line-height: 1;
            margin-bottom: -5px;
            margin-left: 2px;
            width: 230px;
            display: flex;
            .origin-price {
              text-decoration: line-through;
              font-size: 14px;
              color: #999999;
              margin-left: 10px;
            }
          }
        }
        .floor-4 {
          margin-top: 10px;
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          line-height: 1;
          .floor-4-1 {
            font-size: 14px;
            color: #333333;
          }
          .floor-4-2 {
            margin-left: 20px;
            font-size: 14px;
            color: #333333;
          }
        }
        .floor-2 {
          margin-top: 10px;
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-right: 205px;
          line-height: 1;
          .floor-2-1 {
            font-size: 14px;
            color: #333333;
          }
          .floor-2-2 {
            margin-left: 20px;
            font-size: 14px;
            color: #333333;
          }
        }
        .floor-3 {
          margin-top: 10px;
          margin-left: 10px;
          display: flex;
          color: #ffffff;
          font-size: 12px;
          line-height: 1;
          .product-tag-1 {
            width: auto;
            height: 20px;
            background: #ed9d17;
            border-radius: 4px;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 2px 4px;
            font-style: normal;
            font-weight: normal;
          }
          .product-tag-invalid {
            width: auto;
            height: 20px;
            border-radius: 4px;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #999999;
            padding: 2px 4px;
          }
          .product-tag-2 {
            width: 48px;
            height: 20px;
            background: #06ab73;
            border-radius: 4px;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-style: normal;
            font-weight: normal;
          }
          .product-tag-3 {
            color: #fff;
            /*width: auto;*/
            padding: 0 4px;
            height: 20px;
            background: #ea9200;
            border-radius: 4px;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-style: normal;
            font-weight: normal;
          }
        }
      }
      .column-2 {
        img {
          width: 104px;
          height: 104px;
          margin-top: -20px;
        }
      }
    }
    .product-detail-attr {
      margin-left: 10px;
      margin-top: 40px;
      .attr-item-warp {
        margin-top: 2px;
      }
      .attr-item {
        display: inline-block;
        width: 60px;
        // flex-flow: row;
        // justify-content: space-between;
        // align-items: center;
        color: $c6;
        font-size: 12px;
        text-align: justify;
        text-align-last: justify;
        text-justify: distribute-all-lines;
      }
      i {
        font-style: normal;
      }
      .attr-txt {
        color: #333;
        font-size: 12px;
      }
      .product-detail-line {
        /*margin-left: 10px;*/
        .product-detail-attr-common {
          font-size: 12px;
          color: $c3;
          margin-bottom: 5px;
        }
        .product-detail-tag {
          width: 39px;
          height: 18px;
          border: 1px solid #0088ff;
          font-size: 12px;
          font-weight: 400;
          color: #0088ff;
          line-height: 15px;
          display: inline-block;
          text-align: center;
        }
        .product-detail-delivery-info {
          display: flex;
          align-items: center;
          /*&:hover{*/
          /*  .address-list{*/
          /*    display: block;*/
          /*  }*/
          /*}*/
          .product-detail-delivery {
            min-width: 90px;
            height: 26px;
            border: 1px solid #979797;
            display: flex;
            justify-content: center;
            /*line-height: 26px;*/
            cursor: pointer;
            padding-left: 3px;
            padding-right: 3px;
          }
          .product-detail-delivery-tag {
            display: inline-block;
            font-size: 14px;
            color: #ff0000;
            margin-left: 11px;
          }
          .address-list {
            display: none;
            position: absolute;
            top: 26px;
            left: 60px;
            width: 407px;
            min-height: 208px;
            background: #ffffff;
            box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.18);
            z-index: 100;
            cursor: pointer;
            .p-c {
              height: 38px;
              border-bottom: 1px solid $main-col;
              display: flex;
              padding: 12px 0 0 0;
              margin-left: 10px;
              cursor: pointer;
              span {
                margin-right: 10px;
                border: 1px solid $main-col;
                min-width: 72px;
                height: 26px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                cursor: pointer;
                &.active-city {
                  border-bottom: 1px solid #ffffff;
                  /*img{*/
                  /*  width: 9px;*/
                  /*  margin-left: 10px;*/
                  /*}*/
                }
                img {
                  width: 9px;
                  margin-left: 10px;
                }
              }
            }
            .p-c-list {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              padding: 20px 24px;
              cursor: pointer;
              ul {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                li {
                  display: flex;
                  line-height: 1;
                  justify-content: flex-start;
                  text-align: center;
                  margin-bottom: 20px;
                  margin-right: 18px;
                  cursor: pointer;
                  &.select-province {
                    // width: 36px;
                    padding-top: 2px;
                    padding-bottom: 2px;
                    padding-left: 6px;
                    padding-right: 6px;
                    height: 16px;
                    background: $main-col;
                    border-radius: 3px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }

        .product-detail-pay {
          display: flex;
          flex-direction: row;
          align-items: center;
          .product-detail-pay-item {
            font-size: 14px;
            color: #333333;
            display: flex;
            margin-right: 10px;
          }
        }
      }
    }
    .product-detail-btn {
      margin-top: 20px;
      margin-left: 10px;
      display: flex;
      .product-detail-num-btn {
        margin-left: 10px;
        margin-right: 15px;
      }
      .product-detail-add-btn {
        width: 156px;
        height: 44px;
        background: $main-col;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        &:hover {
          background: #126edf;
        }
        &:focus {
          background: #126edf;
        }
      }
      .product-detail-add-btn-invalid {
        width: 156px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        background: #c5c5c5;
      }
      .product-detail-buy-btn {
        width: 136px;
        height: 44px;
        border: 2px solid #fc4948;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #fc4948;
        /*background: #FFF5C7;*/
        background: #ffffff;
        &:hover {
          background: #f0250f;
          color: #ffffff;
        }
        &:focus {
          background: #f0250f;
          color: #ffffff;
        }
      }
      .product-detail-buy-btn-invalid {
        width: 136px;
        height: 44px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        background: #ffffff;
        border: 1px solid #999999;
      }
      .product-detail-right-collect-btn {
        width: 94px;
        height: 44px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: $main-col;
        background: #ffffff;
        border: 1px solid $main-col;
        div {
          margin-left: 7px;
        }
        &:hover {
          background: $main-hover;
          color: #fff;
        }
      }
    }
  }
  .product-detail-right {
    margin-left: 10px;
    /*margin-top: 15px;*/
    width: 220px;
    /*max-height: 340px;*/
    background: #ffffff;
    border: 1px solid #d3ac72;
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    flex-direction: column;
    padding-bottom: 13px;
    .product-detail-right-title {
      width: 100%;
      height: 70px;
      /*background: #FFC9CD;*/
      background: url('~@/assets/img/product/vipUserBg.png');
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .product-detail-right-title-floor1 {
        width: 192px;
        height: 21px;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 21px;
        /*display: -webkit-box;*/
        /*justify-content: center;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
        &:hover {
          color: #2587ff;
        }
      }
      .product-detail-right-title-floor2 {
        display: flex;
        justify-items: center;
        align-items: center;
        width: 100%;
        margin-top: 5px;
        .product-detail-right-vip-text {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50%;
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 27px;

          color: #f47425;
        }
        .product-detail-right-vip-txt {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          color: #ff1b1b;
          margin-left: 25px;
        }
      }
    }
    .product-detail-right-content {
      margin-top: 10px;
      width: 100%;
      .product-detail-line {
        margin-left: 10px;
        margin-bottom: 5px;
        font-size: 12px;
        display: flex;
        flex-direction: row;
        div:nth-child(1) {
          text-align-last: justify;
          width: 97px;
          margin-right: 10px;
          text-align: justify;
          text-justify: inter-ideograph;
        }
        div:nth-child(2) {
          display: flex;
          width: 100px;
          justify-content: flex-start;
        }
      }
      .product-detail-line-1 {
        margin-left: 10px;
        margin-bottom: 5px;
        font-size: 12px;
      }
      ::v-deep .el-rate__icon {
        font-size: 15px;
        margin-right: 3px;
      }
    }
    .product-detail-right-collect {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;
      margin-top: 20px;
      .product-detail-right-collect-product {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 40px;
      }
      .product-detail-right-collect-company {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        .txt {
          color: #333;
          line-height: 1;
        }
        img {
          width: 16px;
          margin-bottom: 12px;
        }
      }
    }

    .divider {
      height: 1px;
      width: 180px;
      margin: 20px 0px 13px;
      background: #ededed;
    }
  }

  img[lazy='error'] {
    width: 146px !important;
    height: 100px !important;
  }
  img[lazy='loading'] {
    width: 146px !important;
    height: 100px !important;
  }
  .h-line {
    width: 10px;
    display: inline-block;
    height: 1px;
    background: #666;
    margin-top: 10px;
  }
}
</style>
